import _taggedTemplateLiteral from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  color: grey;\n  font-family: Nunito, Arial, sans-serif;\n  font-size: 0.75rem;\n  \n  & > span {\n    display: inline-block;\n    margin: 0 20px;\n  }\n  \n  & a {\n    display: inline-block;\n    margin: 0 5px;\n    padding: 5px;\n    \n    &:hover {\n      cursor: pointer\n    }\n    \n    &.active {\n      color: grey;\n    }\n  }\n\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  padding-bottom: 20px;\n\n  & a {\n    display: inline-block;\n    padding: 8px 15px;\n    margin: 0 2px;\n    cursor: pointer;\n    text-decoration: none;\n    color: #fff;\n    background-color: #007bff;\n    border-color: #007bff;\n    border-radius: 0.25rem;\n\n    &:hover {\n      color: #fff;\n      background-color: #0069d9;\n      border-color: #0062cc;\n    }\n    &.active {\n      color: #fff;\n      background-color: #0062cc;\n      border-color: #005cbf;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

/**
 * @file Created on Fri Jul 27 2018
 * @author VBr
 */
import * as React from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react';
import { T } from '../../i18n/T';
import { translate } from "../../../index";
export var Pagination =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Pagination, _React$Component);

  function Pagination(props) {
    var _this;

    _classCallCheck(this, Pagination);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Pagination).call(this, props));
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(Pagination, [{
    key: "render",
    value: function render() {
      var buttons = [];

      if (this.props.showAdditionalInfo) {
        var total = this.props.totalItems;
        var from = this.props.offset + 1;
        var to = from + this.props.limit;
        to = to > this.props.totalItems ? this.props.totalItems : to;
        buttons.push(React.createElement("span", {
          key: "info"
        }, translate('pagination-info', String(from), String(to), String(total))));
      }

      var activePageIsFirst = this.props.activePage === 1;
      var activePageIsLast = this.props.activePage === this.props.totalPages;
      var pageButtons = this.props.pageButtons || 4;
      var totalPages = this.props.totalPages;
      var activePage = this.props.activePage;
      var lastPage = this.props.totalPages;
      var firstPage = 1;
      var nextPage = this.props.activePage + 1;
      var prevPage = this.props.activePage - 1;
      var showNextPrev = pageButtons + 1 < this.props.totalPages;
      var showFirstLast = pageButtons + 1 < this.props.totalPages; // go to first page btn

      if (!activePageIsFirst && showFirstLast) {
        buttons.push(this.renderButton(firstPage, 'pagination-first'));
      } // go to prev page


      if (!activePageIsFirst && showNextPrev) {
        buttons.push(this.renderButton(prevPage, 'pagination-prev'));
      } // do magic for prev and next pages


      var maxButtons = pageButtons < totalPages ? pageButtons : totalPages;
      var prevBtns = [];
      var nextBtns = [];

      for (var i = 1; i <= maxButtons; i++) {
        if (prevBtns.length + nextBtns.length < maxButtons) {
          if (activePage - i > 0) {
            prevBtns.push(this.renderButton(activePage - i));
          }

          if (activePage + i <= totalPages) {
            nextBtns.push(this.renderButton(activePage + i));
          }
        }
      }

      buttons.push(prevBtns.reverse());

      if (totalPages > 1) {
        buttons.push(this.renderButton(activePage));
      }

      buttons.push(nextBtns); // magic done
      // go to next page

      if (!activePageIsLast && showNextPrev) {
        buttons.push(this.renderButton(nextPage, 'pagination-next'));
      } // go to last page


      if (!activePageIsLast && showFirstLast) {
        buttons.push(this.renderButton(lastPage, 'pagination-last'));
      }

      return buttons;
    }
  }, {
    key: "renderButton",
    value: function renderButton(pageNumber, text) {
      var _this2 = this;

      return React.createElement("a", {
        className: pageNumber === this.props.activePage ? 'active' : undefined,
        key: text !== undefined ? text : pageNumber,
        "data-pagenum": pageNumber,
        onClick: function onClick(e) {
          return _this2.handleClick(e, pageNumber);
        }
      }, text ? React.createElement(T, {
        id: text
      }) : pageNumber);
    }
  }, {
    key: "handleClick",
    value: function handleClick(e, pageNumber) {
      e.preventDefault();

      if (this.props.handlePageChange) {
        this.props.handlePageChange(pageNumber);
      }
    }
  }]);

  return Pagination;
}(React.Component);
var Skeleton = observer(function (props) {
  return React.createElement("div", {
    className: props.className
  }, React.createElement(Pagination, {
    activePage: props.activePage,
    totalPages: props.totalPages,
    handlePageChange: props.handlePageChange,
    showAdditionalInfo: props.showAdditionalInfo,
    limit: props.limit,
    offset: props.offset,
    totalItems: props.totalItems
  }));
});
var StyledPagination = styled(Skeleton)(_templateObject());
/**
 * Styled pagination
 */

export default (function (props) {
  return React.createElement(StyledPagination, Object.assign({}, props));
});
var MiniPagination = styled(Skeleton)(_templateObject2());
export var MinimalisticPagination = function MinimalisticPagination(props) {
  return React.createElement(MiniPagination, Object.assign({}, props));
};